import { useEffect, useState } from 'react';
import { FinancialAccountNode } from '../services/orgs/interfaces';
import { getKybById } from '../services/vault/kyb';
import { extractErrorMessage } from '../util/errorMessage';

export default function useKyb({
  financialAccountNode,
  financialAccountIsFinished,
  refreshKyb,
}: {
  financialAccountNode?: FinancialAccountNode;
  financialAccountIsFinished: boolean;
  refreshKyb: Symbol;
}): { kyb?: Kyb; errorMessage?: string; isFinished: boolean } {
  const [kyb, setKyb] = useState<Kyb>();
  const [errorMessage, setErrorMessage] = useState<string>();
  const [isFinished, setIsFinished] = useState(false);

  useEffect(() => {
    const gatherData = async (): Promise<void> => {
      if (financialAccountIsFinished && financialAccountNode === undefined) {
        setIsFinished(true);
      } else if (
        kyb === undefined &&
        financialAccountNode?.kybId !== undefined
      ) {
        try {
          const retrievedKyb = await getKybById(financialAccountNode.kybId);
          setKyb(retrievedKyb);
        } catch (e) {
          setErrorMessage(extractErrorMessage(e));
        } finally {
          setIsFinished(true);
        }
      } else if (
        financialAccountNode?.kybId === undefined ||
        financialAccountNode?.kybId === null
      ) {
        setIsFinished(true);
      }
    };
    gatherData();
  }, [
    financialAccountIsFinished,
    financialAccountNode,
    financialAccountNode?.kybId,
    kyb,
  ]);

  useEffect(() => {
    const gatherData = async (): Promise<void> => {
      if (!financialAccountNode?.kybId) {
        return;
      }
      try {
        const retrievedKyb = await getKybById(financialAccountNode.kybId);
        setKyb(retrievedKyb);
      } catch (e) {
        setErrorMessage(extractErrorMessage(e));
      }
    };
    gatherData();
  }, [financialAccountNode?.kybId, refreshKyb]);

  return {
    kyb,
    errorMessage,
    isFinished,
  };
}
